import { useNavigate, useSearchParams } from 'react-router-dom'

export default (
	key: 'roles' | 'candidates',
): {
	filter: string | null
	setFilter: (filter: string | null) => void
} => {
	const [searchParams] = useSearchParams()
	const navigate = useNavigate()

	const filter = new URLSearchParams(searchParams).get(key)

	const setFilter = (filter: string | null): void => {
		const newParams = new URLSearchParams(window.location.search)

		newParams.delete(key)
		if (filter) {
			newParams.set(key, filter)
		}

		navigate(window.location.pathname + '?' + newParams + window.location.hash)
	}

	return {
		filter,
		setFilter,
	}
}
